import React from 'react';
import { Drawer, Spin, List, Avatar, Typography, Tag, Empty } from 'antd';
import { HistoryOutlined, PlayCircleOutlined, ShopOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Text } = Typography;

const BidActivityDrawer = ({
  visible,
  onClose,
  loading,
  bidActivityData,
  currentUser,
  auction,
  lots,
  setSelectedLot,
  bidActivityCount,
  setLastViewedActivityCount,
  formatCurrency
}) => {

  const handleClose = () => {
    setLastViewedActivityCount(bidActivityCount);
    onClose();
  };

  const handleAfterOpenChange = (open) => {
    if (open) {
      setLastViewedActivityCount(bidActivityCount);
    }
  };

  return (
    <Drawer
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <HistoryOutlined style={{ color: '#faad14' }} />
          <span>Bid Activity</span>
        </div>
      }
      open={visible}
      onClose={handleClose}
      afterOpenChange={handleAfterOpenChange}
      width={500}
      placement="right"
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Spin size="large" />
          <div style={{ marginTop: '16px' }}>Loading bid activity...</div>
        </div>
      ) : bidActivityData.length === 0 ? (
        <Empty
          description="No bid activity yet"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ padding: '40px 20px' }}
        />
      ) : (
        <List
          dataSource={bidActivityData}
          renderItem={(bid) => {
            const userName = bid.user
              ? `${bid.user.first_name || ''} ${bid.user.last_name || ''}`.trim() || 'Anonymous'
              : 'Anonymous';
            const isCurrentUser = currentUser && bid.user && Number(bid.user.id) === Number(currentUser.id);
            const isAuctionOwner = bid.is_auction_owner || (auction && bid.user_id && Number(bid.user_id) === Number(auction.user_id));
            const lot = lots.find(l => l.id === bid.lot_id);

            return (
              <List.Item
                style={{
                  cursor: 'pointer',
                  padding: '12px',
                  marginBottom: '8px',
                  background: isCurrentUser ? '#e6f7ff' : '#fafafa',
                  borderRadius: '8px',
                  border: isCurrentUser ? '1px solid #91d5ff' : '1px solid #f0f0f0'
                }}
                onClick={() => {
                  if (lot) setSelectedLot(lot);
                }}
              >
                <List.Item.Meta
                  avatar={
                    <Avatar
                      style={{
                        background: isCurrentUser ? '#1890ff' : '#d9d9d9',
                        color: '#fff'
                      }}
                    >
                      {userName.charAt(0).toUpperCase()}
                    </Avatar>
                  }
                  title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      {!isCurrentUser && <Text strong style={{ fontSize: '13px' }}>{userName}</Text>}
                      {isCurrentUser && <Tag color="blue" size="small">You</Tag>}
                      {bid.is_start_bid && (
                        <Tag 
                          color="blue"
                          icon={<PlayCircleOutlined />}
                          style={{ margin: 0, fontSize: '9px', padding: '1px 6px', fontWeight: 600, borderRadius: '4px' }}
                        >
                          Started Lot
                        </Tag>
                      )}
                      {bid.is_vendor_bid && (
                        <Tag 
                          color="purple"
                          icon={<ShopOutlined />}
                          style={{ margin: 0, fontSize: '9px', padding: '1px 6px', fontWeight: 600, borderRadius: '4px' }}
                        >
                          Vendor Bid
                        </Tag>
                      )}
                      {bid.is_winning && !isAuctionOwner && <Tag color="gold" size="small">Winning</Tag>}
                      <Text type="secondary" style={{ fontSize: '11px' }}>bid on</Text>
                      <Text strong style={{ fontSize: '13px', color: '#1890ff' }}>Lot #{bid.lot_number}</Text>
                    </div>
                  }
                  description={
                    <div style={{ marginTop: '4px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <Text strong style={{ fontSize: '16px', color: '#52c41a' }}>
                          {formatCurrency(bid.amount)}
                        </Text>
                        <Text type="secondary" style={{ fontSize: '11px' }}>
                          {moment(bid.created_at).format('MMM DD, hh:mm A')}
                        </Text>
                      </div>
                      {bid.lot_title && (
                        <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginTop: '4px' }}>
                          {bid.lot_title}
                        </Text>
                      )}
                    </div>
                  }
                />
              </List.Item>
            );
          }}
        />
      )}
    </Drawer>
  );
};

export default BidActivityDrawer;
